import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core'
import { faFacebookF, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { socialLogin } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.actions'
import { SocialAuthService } from '@abacritt/angularx-social-login'
import { FacebookLoginProvider, GoogleLoginProvider, SocialUser } from '@abacritt/angularx-social-login'
import { SocialLoginTypeEnum } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'
import { isInApp } from 'libs/shared/utils/helpers/src/'
import { Action } from '@ngrx/store'

@Component({
  selector: 'gb-social-login-register',
  templateUrl: './gb-social-login-register.component.html',
  styleUrls: ['./gb-social-login-register.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbSocialLoginRegisterComponent {
  @Input() dialog = false
  @Input() redirectHome = true
  @Input() onSuccess?: Action

  auctionUrlName$ = this.auctionFacade.auctionUrlName$
  facebookLoginEnabled$ = this.auctionFacade.facebookLoginEnabled$
  googleLoginEnabled$ = this.auctionFacade.googleLoginEnabled$

  faFacebookF = faFacebookF
  faGoogle = faGoogle

  constructor(
    private auctionFacade: AuctionFacade,
    private authFacade: AuthFacade,
    private socialAuthService: SocialAuthService,
  ) {}

  facebookSignIn(): void {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then((socialUser: SocialUser) =>
      this.authFacade.dispatch(
        socialLogin({
          accessToken: socialUser.authToken,
          provider: SocialLoginTypeEnum.Facebook,
          dialog: this.dialog,
          redirectHome: this.redirectHome,
          onSuccess: this.onSuccess,
        }),
      ),
    )
  }

  googleSignIn(): void {
    this.socialAuthService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then((accessToken) =>
      this.authFacade.dispatch(
        socialLogin({
          accessToken: accessToken,
          provider: SocialLoginTypeEnum.Google,
          dialog: this.dialog,
          redirectHome: this.redirectHome,
          onSuccess: this.onSuccess,
        }),
      ),
    )
  }

  /**
   * This function would hide the whole component in case it is rendered in one of those in app browser
   * which breaks google login and some other google js libs like address autocomplete
   * */
  shouldShowSocialLogin() {
    return !isInApp()
  }
}
